import { computed } from 'vue'
import { useClockStore } from '../stores/clock'
import { storeToRefs } from 'pinia'

export const useNextVoteText = () => {
  const { now } = storeToRefs(useClockStore())

  const nextVoteText = computed(() => {
    const date = new Date(now.value)
    const day = date.getDay()

    return day === 0 || day === 5 || day === 6 ? 'Maandagochtend' : 'Morgenochtend'
  })

  return { nextVoteText }
}
